// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"08d38d5f","384":"4ae7f533","859":"16542dde"}[chunkId] + ".chunk.css";
};